import type { ProductUpdatesEnvironment } from './interface';
import environmentUrls from '../../config/environments.json';

/**
 * Dynamic environment (production API + staging baseUrl).
 * URLs sourced from config/environments.json (shared with SSR server).
 */

const url = new URL(location.href);
export const environment: ProductUpdatesEnvironment = {
  production: false,
  angularProdMode: true,
  apiUrl: environmentUrls.staging.apiUrl + '/',
  baseUrl: `${url.origin}/${url.pathname
    .split('/')
    .filter(v => !!v)
    .slice(0, 2)
    .join('/')}`,
  i18n: {
    defaultLocale: 'en',
    availableLocales: ['en', 'de', 'nl', 'fr'],
  },
  sentry: {
    dsn: 'https://3369492dd834bc8a22d13dab2c3ee74d@o4511234536570880.ingest.de.sentry.io/4511234581397584',
    environmentName: 'development',
  },
};
